<template>
    <div class="container">
        <div v-if="logoutSplash" class="logout-splash">
        <span>{{ logoutMessage }}</span>
        </div>
        <div class="profile-container mt-10" v-if="profile">
            <div class="profile-image">
                <div class="profile-picture">
                    <span v-if="escort_data.profilepic == null" class="select-profile">
                        <img
                        src="../assets/no_image.png"
                        class="large-profile-pic"
                        alt=""
                        width="140px"
                        height="140px"
                        style="border-radius: 50%; cursor: pointer;"
                        @click="escortHasStory ? openStoryViewer() : openStoryUpload()"
                        >
                       
                    </span>

                    <span v-else class="select-profile">
                        <img
                        :src="escort_data.profilepic"
                        class="large-profile-pic"
                        alt=""
                        width="140px"
                        height="140px"
                        style="border-radius: 50%; cursor: pointer;"
                        @click="escortHasStory ? openStoryViewer() : openStoryUpload()"
                        >
                      
                        <div class="d-flex likes-followers justify-content-center">
                        <h4 class="badge badge-info">{{ countLikes }} likes</h4>&nbsp;
                        <h4 class="badge badge-primary">{{ countFollowers }} followers</h4>
                        </div>
                    </span>
                </div>

                <div class="profile-info">
                    <h3>{{ escort_data.username }} ({{ escort_data.age }})
                        <span v-if="escort_data.activation_paid == 1" class="verified-icon" title="Verified">
                            <i class="fa fa-check-circle text-success"></i>
                        </span>
                    </h3>
                    <p>
                        {{ escort_data.location }} {{ escort_data.state }} | {{ escort_data.gender }} | <i class="fa fa-phone"></i>
                        <span v-if="escort_data.activation_paid == 1">
                            {{ escort_data.phone_number }}
                        </span>
                        <span v-else>
                            {{maskPhoneNumber(escort_data.phone_number)}}
                        </span>
                    </p>
                    <hr class="mobile-line">
                    <p>{{ escort_data.bio }} </p>

                </div>
            </div>
            <div class="profile-edit-button">
                <button type="button" class="btn-edit" @click="addBanks(userid)">
                    <i class="fa fa-plus"></i> Add Banks
                </button>
            </div>
        </div>

        <div v-if="showBankModal" class="bank-modal-backdrop" @click.self="closeBankModal">
            <div class="bank-modal-card">
                <div class="bank-modal-header">
                    <div>
                        <span class="bank-modal-eyebrow">Bank details</span>
                        <h5 class="bank-modal-title">Add a new bank account</h5>
                        <p class="bank-modal-subtitle mb-0">
                            Save the account details here so future payouts and transfers are easier to manage.
                        </p>
                    </div>

                    <button type="button" class="bank-modal-close" @click="closeBankModal" aria-label="Close">
                        <i class="fa fa-times"></i>
                    </button>
                </div>

                <div class="bank-modal-body">
                    <div class="bank-summary-card">
                        <i class="fa fa-university"></i>
                        <div>
                            <p class="bank-summary-label mb-1">Active profile</p>
                            <p class="bank-summary-value mb-0">{{ escort_data.username }}</p>
                        </div>
                    </div>

                    <input type="hidden" v-model="userid">

                    <div class="bank-field-group">
                        <label class="bank-field-label">Account name</label>
                        <input type="text" class="bank-input" v-model="account_name" placeholder="Enter account name">
                    </div>

                    <div class="bank-field-group">
                        <label class="bank-field-label">Bank name</label>
                        <input type="text" class="bank-input" v-model="bank_name" placeholder="Enter bank name">
                    </div>

                    <div class="bank-field-group">
                        <label class="bank-field-label">Account number</label>
                        <input type="text" class="bank-input" v-model="account_number" placeholder="Enter account number">
                    </div>
                </div>

                <div class="bank-modal-actions">
                    <button class="btn bank-btn bank-btn--ghost" type="button" @click="closeBankModal">
                        Cancel
                    </button>
                    <button class="btn bank-btn bank-btn--primary" type="button" @click="saveBank">
                        <span v-if="loading"><i class="fas fa-spinner fa-spin"></i> Saving...</span>
                        <span v-else><i class="fa fa-save"></i> Save bank</span>
                    </button>
                </div>
            </div>
        </div>

        <div class="p-2">
            <div class="card mt-3 bank-table-card">
                <div class="card-header bank-table-header">
                <div>
                    <p class="bank-table-eyebrow mb-1">Saved accounts</p>
                    <h6 class="mb-0"><i class="fa fa-home"></i> My Bank</h6>
                </div>
                </div>
                <div class="card-body shadow bank-table-shell">
                <table class="table bank-table align-middle mb-0">
                    <thead>
                    <tr>
                        <th>Account name</th>
                        <th>Bank name</th>
                        <th>Account number</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item, index) in banks" :key="index" class="bank-table-row">
                        <td>
                            <div class="bank-cell-main">{{ toTitleCase(item.account_name) }}</div>
                        </td>
                        <td>
                            <div class="bank-cell-main">{{ toTitleCase(item.bank_name) }}</div>
                        </td>
                        <td>
                            <div class="bank-account-pill">{{ item.account_number }}</div>
                        </td>
                    </tr>
                    </tbody>
                </table>
                </div>
                <!-- Empty State -->
                <div v-if="banks.length === 0" class="bank-empty-state">
                    <i class="fa fa-university"></i>
                    <h6>No bank accounts yet</h6>
                    <p>Use Add Banks to save your payout details securely.</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import swal from 'sweetalert2';
//import imageCompression from 'browser-image-compression';
//import * as bootstrap from 'bootstrap'

export default {

    components: {    
    },
    
    data() {
    return {
        pageLoader: false,
        image_path: '',
        splashScreen: false,
        selectedImage: null,
        showImageDialog: false,
        profile: true,
        edit_profile: false,
        btn_success: false,
        btn_success2: false,
        previewLoading: false,
        previewImage:'',
        photo_desc: '',
        photo_price: 0,
        video_price: '',
        is_picture_premium: false,
        showPremiumPopup: false,
        previewVideo:'',
        myprofile: '',
        age: '',
        fullname: '',
        firstname:'',
        middlename: '',
        lastname: '',
        email: '',
        phone: '',
        day: '',
        month: '',
        year: '',
        gender: '',
        location: '',
        state: '',
        from:'',
        to:'',
        
        aboutyou: '',
        occupation: '',
        religion: '',
        sexuality: '',
        relationship_goal: '',
        loading: false,
       
        userphoto: '',
        country: '',
        profile_pictures:[],
        options: [],
        transport: '',

        showModal: false,
        showBankModal: false,
        subscriptions: [],
        photos: '',
        profile_photo: '',
        userid: '',
        escort_data: '',
        escort_info:[],
        escort_tour: [],
        escortid: '',
        rates: [],
        countLikes: 0,
        countFollowers: 0,
        listFollowers: [],
        account_name: '',
        bank_name: '',
        account_number: '',
        profilePictureFile: '',
        profileVideoFile: '',
        escort_video: [],
        services: [],
        video_description: '',
        is_video_premium: '',
        logoutSplash: false,
        logoutMessage: "",

        banks: [],

        };
    },

async beforeMount(){
    this.userid = this.$route.params.escortid;
},

async mounted(){
    await this.listEscortProfile(this.userid)
    await this.fetchBanks(this.userid)
    await this.listMyProfile(this.userid);
    
    this.generateYears();

    const now = Date.now();
    const lastShown = localStorage.getItem('lastGalleryWarningTime');

    // 5 minutes = 300,000 milliseconds
    const fiveMinutes = 5 * 60 * 1000;

    if (!lastShown || now - parseInt(lastShown) > fiveMinutes) {
      this.showUploadWarning = true;
      localStorage.setItem('lastGalleryWarningTime', now.toString());
    }
},


methods: {
    alertBoost() {
    alert("You must boost your profile before using this feature!");
    },
    closeModal() {
      this.showUploadWarning = false;
    },
    isImagePage(filePath) {
        return /\.(jpg|jpeg|png|gif|webp)$/i.test(filePath);
    },
    isVideoPage(filePath) {
        return /\.(mp4|mov|avi|mkv|webm)$/i.test(filePath);
    },

    async fetchBanks(userid){
        try{
        const response = await this.$http.get(`/fetch-user-bank/${userid}`,{} )
        this.banks = response.data.data;
    
        }catch (err) {
            console.log(err);
        }
    },

    maskPhoneNumber(phone) {
        if (!phone) return '';
        return phone.slice(0, 4) + '*'.repeat(phone.length - 4);
    },

     // Trigger file input
   openStoryUpload() {
    this.$refs.storyInput.click();
   },
    // Handle uploaded file
    async handleStoryUpload(event) {
    const file = event.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('escort_id', this.userid);
    formData.append('story_gallery_video', file);

    try {
        const response = await this.$http.post('/upload-story', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
        });

        if (response.data.success) {
        // Show splash message
        this.logoutMessage = response.data.message || "Story uploaded successfully!";
        this.logoutSplash = true;

        // Hide splash after 2.5s
        setTimeout(() => {
            this.logoutSplash = false;
        }, 2500);

        } else {
        alert(response.data.message || 'Failed to upload story');
        }
    } catch (err) {
        console.error('Story upload error:', err);
        alert('Upload failed. Please try again.');
    }
    },

    backProfile() {
        this.profile = true,
        this.edit_profile = false
    },

    async pickFile() {
    
    const input = this.$refs.fileInput;
    const file = input.files && input.files[0];
    if (!file) return;

    const fileType = file.type;

    // Reset previous preview state
    this.isImage = false;
    this.isVideo = false;
    this.previewImage = null;

    // Check type and preview accordingly
    if (fileType.startsWith("image/")) {
        // Handle image preview
        const reader = new FileReader();
        reader.onload = (e) => {
        this.previewImage = e.target.result; // Show image preview
        this.isImage = true;
        };
        reader.readAsDataURL(file);
    } else if (fileType.startsWith("video/")) {
        // Handle video preview (use object URL for performance)
        this.previewImage = URL.createObjectURL(file);
        this.isVideo = true;
    } else {
        alert("Only image and video files are supported.");
        return;
    }

    // Store file for upload
    this.profilePictureFile = file;

    // Optional: emit event to parent
    this.$emit("input", file);

    // Indicate success (e.g. enable save button)
    this.btn_success = true;
    },

    async listMyProfile(userid){
         try{
            this.pageLoader = true
            const response = await this.$http.post('/list-profile',{ user_id: userid}, {
                headers: { 
                //"x-api-key": `${process.env.VUE_APP_API_KEY}`,
                'Content-Type': 'application/json' 
               },
            } )
            this.escort_data = response.data.data[0];
            this.isEscort = this.escort_data.account_type
            await localStorage.setItem('email', this.escort_data.email_address);

            if (this.escort_data.account_type === 'escort') {
                await this.listEscortTour(this.escortid)
                await this.getBookings(this.escortid)
                await this.getTransactions(this.escortid)
                await this.fetchRates();
            }

            this.pageLoader = false
        
            }catch (err) {
                console.log(err);
            }
    },
    async listEscortProfile(userid){
         try{

            const response = await this.$http.post('/list-escort-byid',{ user_id: userid} )
            this.escort_info = response.data.data;
            this.escortid = this.escort_info.hid
            this.is_boost_status = response.data.is_boost_status;

            this.getFollowers(this.escortid)
            this.getLikes(this.escortid)
            this.getTruthDareRequests(this.escortid)

            }catch (err) {
                console.log(err);
            }
    },
    async listEscortVideos(userid){
        try{
        const response = await this.$http.post('/list-escort-videos',{ user_id: userid} )
        this.escort_video = response.data.data;

        }catch (err) {
            console.log(err);
        }
    },
    async addBanks(userid){
        this.userid = userid || this.userid;
        this.showBankModal = true;
    },

    closeBankModal() {
        this.showBankModal = false;
        this.account_name = '';
        this.bank_name = '';
        this.account_number = '';
    },

    async saveBank() {
        try {
            if (!this.account_name || !this.bank_name || !this.account_number) {
                this.logoutMessage = "Please fill all required fields.";
                this.logoutSplash = true;
                setTimeout(() => {
                    this.logoutSplash = false;
                }, 2500);
                return;
            }

            this.loading = true;
            const response = await this.$http.post('/create-bank', {
                userid: this.userid,
                account_name: this.account_name,
                bank_name: this.bank_name,
                account_number: this.account_number,
            });

            this.loading = false;

            if (response.data.success) {
                this.logoutMessage = response.data.message || "Bank added successfully!";
                this.logoutSplash = true;
                setTimeout(() => {
                    this.logoutSplash = false;
                }, 2500);

                this.closeBankModal();
                await this.fetchBanks(this.userid);
            } else {
                swal.fire({
                    icon: 'warning',
                    width: 450,
                    text: response.data.message,
                });
            }
        } catch (err) {
            console.error(err);
            this.loading = false;
            swal.fire({
                icon: 'error',
                title: 'Server Error',
                text: err.response ? err.response.data.message : err.message,
            });
        }
    },


    async getFollowers(userid) {
    try {

        const response = await this.$http.get(`/escort-followers/${userid}`, {});
        this.countFollowers = response.data.data.length;
        this.listFollowers = response.data.data;
      
    } catch (err) {
      console.error(err);
      swal.fire({
        icon: 'error',
        title: 'Error',
        text: err.response?.data?.message || 'Server error occurred.',
        width: 400
      });
    }
    },

    toTitleCase(value) {
        if (!value) return '';
        return String(value)
            .toLowerCase()
            .replace(/\b\w/g, (char) => char.toUpperCase());
    },

    formatAmount(value) {
        return new Intl.NumberFormat('en-NG', {
        style: 'currency',
        currency: 'NGN',
        minimumFractionDigits: 2
        }).format(value);
    },

    async widthdrawFee(amount, truthdare_id) {
        try {
            const response = await this.$http.post("/transfer-wallet", {
                email: this.escort_data.email_address,
                amount: amount,
                user_id: this.userid,
                payment_reference: Date.now(),
                booking_id: truthdare_id
            });

            if (response.data.success) {
                alert(`Transfer of ${amount} successfully!`);
                window.location.reload()

            } else {
            alert(`Failed to transfer ${amount}.`);
            }
        } catch (err) {
            console.error(err);
            alert(`Error occurred while transfering of ${amount}`);
        }
    }

    },

}

</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=DM+Sans&family=Raleway&display=swap');
/* Bank modal */
.bank-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 1rem;
  background: rgba(5, 8, 20, 0.72);
  backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.bank-modal-card {
  width: min(100%, 560px);
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 24px;
  background: linear-gradient(180deg, #13111c 0%, #0f1728 100%);
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.45);
}

.bank-modal-header {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: flex-start;
  padding: 24px 24px 20px;
  background: linear-gradient(135deg, rgba(211, 62, 116, 0.96), rgba(106, 17, 203, 0.92));
  color: #fff;
}

.bank-modal-eyebrow {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.14);
  color: rgba(255, 255, 255, 0.9);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.bank-modal-title {
  margin-top: 10px;
  color: #fff !important;
  font-size: 1.3rem;
  font-weight: 800;
  line-height: 1.35;
}

.bank-modal-subtitle {
  margin-top: 8px;
  color: rgba(255, 255, 255, 0.82);
  font-size: 0.95rem;
  line-height: 1.55;
}

.bank-modal-close {
  width: 38px;
  height: 38px;
  border: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.14);
  color: #fff;
  flex-shrink: 0;
}

.bank-modal-body {
  padding: 24px;
}

.bank-summary-card {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 18px;
  padding: 16px 18px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.04);
  color: #fff;
}

.bank-summary-card i {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(211, 62, 116, 0.22), rgba(255, 138, 0, 0.2));
  color: #fff;
  flex-shrink: 0;
}

.bank-summary-label {
  color: rgba(255, 255, 255, 0.64);
  font-size: 0.78rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.bank-summary-value {
  color: #fff;
  font-size: 1.05rem;
  font-weight: 700;
  word-break: break-word;
}

.bank-field-group {
  margin-bottom: 14px;
}

.bank-field-label {
  display: block;
  margin-bottom: 0.55rem;
  color: rgba(255, 255, 255, 0.82);
  font-size: 0.9rem;
  font-weight: 700;
}

.bank-input {
  width: 100%;
  min-height: 50px;
  padding: 0.8rem 1rem;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.05);
  color: #fff;
  outline: none;
}

.bank-input::placeholder {
  color: rgba(255, 255, 255, 0.42);
}

.bank-input:focus {
  border-color: rgba(211, 62, 116, 0.5);
  box-shadow: 0 0 0 4px rgba(211, 62, 116, 0.12);
}

.bank-modal-actions {
  display: flex;
  gap: 10px;
  padding: 0 24px 24px;
}

.bank-btn {
  flex: 1;
  min-height: 48px;
  border-radius: 14px;
  font-weight: 700;
}

.bank-btn--primary {
  background: linear-gradient(135deg, #d33e74, #b82f62);
  border: 0;
  color: #fff;
  box-shadow: 0 12px 28px rgba(211, 62, 116, 0.28);
}

.bank-btn--ghost {
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.08);
  color: #fff;
}

.bank-table-card {
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 20px;
  background: linear-gradient(180deg, #13111c 0%, #0f1728 100%);
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.22);
}

.bank-table-header {
  padding: 18px 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  background: linear-gradient(135deg, rgba(211, 62, 116, 0.92), rgba(106, 17, 203, 0.86));
  color: #fff;
}

.bank-table-eyebrow {
  color: rgba(255, 255, 255, 0.75);
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.bank-table-header h6 {
  color: #fff;
  font-size: 1rem;
  font-weight: 800;
}

.bank-table-shell {
  padding: 0;
  overflow-x: auto;
}

.bank-table {
  margin-bottom: 0;
  min-width: 640px;
  color: #fff;
}

.bank-table thead th {
  padding: 14px 18px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.03);
  color: rgba(255, 255, 255, 0.68);
  font-size: 0.76rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.bank-table tbody tr {
  border-color: rgba(255, 255, 255, 0.06);
  transition: transform 0.2s ease, background 0.2s ease;
}

.bank-table tbody tr:hover {
  background: rgba(255, 255, 255, 0.04);
}

.bank-table tbody td {
  padding: 16px 18px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  vertical-align: middle;
  color: #1f2937;
}

.bank-cell-main {
  color: #1f2937;
  font-weight: 700;
  line-height: 1.35;
}

.bank-account-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 140px;
  padding: 0.55rem 0.85rem;
  border-radius: 999px;
  border: 1px solid rgba(31, 41, 55, 0.16);
  background: rgba(255, 255, 255, 0.72);
  color: #1f2937;
  font-weight: 700;
  letter-spacing: 0.02em;
}

.bank-table tbody tr:last-child td {
  border-bottom: 0;
}

.bank-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 28px 18px 30px;
  text-align: center;
  color: rgba(255, 255, 255, 0.72);
}

.bank-empty-state i {
  width: 48px;
  height: 48px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: rgba(211, 62, 116, 0.12);
  color: #f9a8d4;
}

.bank-empty-state h6 {
  margin: 0;
  color: #fff;
  font-size: 1rem;
  font-weight: 800;
}

.bank-empty-state p {
  margin: 0;
  max-width: 320px;
  font-size: 0.9rem;
  line-height: 1.6;
}

@media (max-width: 576px) {
  .bank-modal-backdrop {
    padding: 0.75rem;
  }

  .bank-modal-header {
    padding: 18px 18px 16px;
  }

  .bank-modal-body {
    padding: 18px;
  }

  .bank-modal-actions {
    padding: 0 18px 18px;
    flex-direction: column-reverse;
  }

  .bank-table-header {
    padding: 16px 18px;
  }

  .bank-table thead th,
  .bank-table tbody td {
    padding-left: 14px;
    padding-right: 14px;
  }
}

.popup-actions button {
  margin: 5px;
}
.logout-splash {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  font-family: 'Raleway';
  font-style: normal;
  background-color: #0A070F; /* green success */
  color: white;
  padding: 15px;
  text-align: center;
  font-weight: bold;
  z-index: 9999;
  box-shadow: 0 2px 5px rgba(0,0,0,0.3);
  transition: top 0.3s ease-in-out;
}
.preview-box {
  width: 100%;
  height: 100%;
  border-radius: 10px;
  background-size: cover;
  background-position: center;
}

.preview-video {
  width: 100%;
  height: 100%;
  border-radius: 10px;
  object-fit: cover;
}

.loading-overlay {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: transparent;
  position: absolute;
  z-index: 10;
}
.modal-header{
    background: #D33E74 !important;
    color: #fff;
}
.btn-primary{
    background: #D33E74 !important;
    color: #fff;
    border: 0px;
}
.image-upload-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 1rem;
}
.account-switch{
    width: 120px;
}
.video-upload-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 1rem;
}
.img-fluid{
    border-radius: 10px;
    width: 100%;
    aspect-ratio: 4 / 5;
    object-fit: cover;
    border-radius: 10px;
    transition: transform 0.3s ease-in-out; /* Optional for smooth effect */
  }
.likes-followers{
    margin-top: 10px;
    display: flex;
    flex-direction: row;
    justify-content: center;

    h4{
        font-family: 'DM Sans';
        font-style: normal;
        font-weight: 500;
        font-size: 11px;
        color: #FFFFFF;
    }
}

@media screen and (max-width: 768px) {
.likes-followers{
    margin-top: -10px;
}
}

.image-preview {
  width: 160px;
  height: 160px;
  background-color: #f0f0f0;
  background-size: cover;
  background-position: center;
  border: 2px dashed #ccc;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: border-color 0.3s ease;
}

.image-preview:hover {
  border-color: #D33E74;
}

.video-preview {
  width: 160px;
  height: 160px;
  background-color: #f0f0f0;
  background-size: cover;
  background-position: center;
  border: 2px dashed #ccc;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: border-color 0.3s ease;
}

.video-preview:hover {
  border-color: #D33E74;
}

.upload-placeholder {
  text-align: center;
  color: #888;
  font-size: 14px;
}

.video-placeholder {
  text-align: center;
  color: #888;
  font-size: 14px;
}

.file-hidden {
  display: none;
}

.video-hidden {
  display: none;
}

.upload-actions {
  display: flex;
  flex-direction: column;
  margin-top: 10px;
}
.photo_desc{
    border: solid 0px;
    border-radius: 5px;
    background: #fff;
    font-size: 14px;
    font-family: 'Raleway';
    font-style: normal;
}

.video-actions {
  margin-top: 10px;
}

.rates {
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 600;
    margin: 20px 0;
}
@media screen and (max-width: 768px) {
    .model-category{
        text-align: center;
    }
    .form-switch{
        text-align: center;
    }
    .rate-row {
        display: flex;
        flex-direction: column;
    }
    .rate-inputs {
        display: flex;
        flex-direction: column;
    }
}
.label-title {
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 10px;
  display: block;
}
.rate-row {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
}
.rate-inputs {
  display: flex;
  gap: 10px;
  flex: 1;
}
.input-textx {
  padding: 8px;
  width: 100%;
}
.btn-add, .btn-remove, .btn-user-login {
    margin-top: 10px;
    color: #D33E74;
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 600;
    font-size: 13px;
}

.label-title{
    font-family: 'Raleway';
    font-weight: bold;
    font-size: 14px;
    color: #fff;
    background: #0A070F;
    border-radius: 10px;
    padding: 0.3rem;
}

.checkbox-group {
  margin-bottom: 15px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.checkbox-group label {
  font-size: 14px;
  color: #D33E74;
}
.btn-user-login {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px 5px;
    background: #D33E74;
    border-radius: 50px;
    color: #fff;
    width: 150px;
    height: 40px;
}
.label {
  display: block;
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 5px;
}

.bio-tab{
    margin-top: 20px;
}
.nav-link{
    color: #D33E74;
}
.nav-tabs{
  border-bottom: 0px solid #111112;
}
 .nav-tabs .nav-link {
    cursor: pointer;
    font-family: 'Raleway';
    font-style: normal;
    font-size: 13px;
 }

.nav-tabs .nav-link.active {
    background-color: #D33E74;
    color: white;
    border-radius: 0.25rem;
    font-family: 'Raleway';
    font-style: normal;
    font-size: 13px;
}

.loader{
    width:100%;
    height:300px;
    display:flex;
    align-items:center;
    justify-content:center;
    gap:20px;
    margin-top:-300px
  }
  .mobile-line{
    display: flex;
    color: #767475;
    width: 90%;
}
  .dot{
    height:40px;
    width:40px;
    border-radius:50%;
  }

.tab-content{
    background: #111112 !important;
    color: #fff !important;
    width: 100%;
    div p {
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 600;
        font-size: 10px;
    }
}
  .dot:nth-child(1){
    background-color:red;
    animation: jump 0.6s 0.5s ease-in infinite
  }
  .dot:nth-child(2){
    background-color:blue;
    animation: jump 0.6s 0.7s ease-in infinite
  }
  .dot:nth-child(3){
    background-color:orange;
    animation: jump 0.6s 0.9s ease-in infinite
  }
  
  
  @keyframes jump{
    0%{
      transform: translate3D(0,0,0);
      opacity: 0;
    }
      50%{
      transform: translate3D(0,-15px,0);
        opacity: 0.5;
    }
      100%{
      transform: translate3D(0,0,0);
        opacity: 1;
    }
  }

  .modal-window {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 999;
    visibility: hidden;
    opacity: 0;
    pointer-events: none;
    transition: all 0.3s;
    &:target {
      visibility: visible;
      opacity: 1;
      pointer-events: auto;
    }
    & > div {
      width: 580px;
      height: 480px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      padding: 2em;
      border: 1px solid #2F2F2F;
      backdrop-filter: blur(13px);
      background: url(../assets/modal_bg.png) no-repeat fixed center, #0A070F;
      box-sizing: border-box;
    }
    header {
      font-weight: bold;
    }
    h1 {
      font-size: 150%;
      margin: 0 0 15px;
    }
    h2 {
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 500;
        font-size: 24px;
        line-height: 23px;
        text-align: center;
        color: #FFFFFF;
    }
    .welcome {
        margin-top: 8px;
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 23px;
        text-align: center;
        color: #FFFFFF;
    }
    label {
        text-align: left;
        color: #fff;
        font-size: 12px;
        margin-left:15px;
        margin-bottom: -6px;
    }
    span {
        margin-bottom: 20px;
    }

}
.modal-container{
    display: flex;
    flex-direction: row;
}
.login-modal-box {
    box-sizing: border-box;
    padding: 10px 52px;
    width: 100%;
    height: 45px;
    background: #2D2D2D;
    border: 0 solid;
    border-radius: 50px;
    font-size: 12px;
    color: #fff !important;
  }

  .btn-login {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px;
    gap: 10px;
    background: #D33E74;
    border-radius: 82px;
    margin-top: 8px;
    color: #fff;
    width: 100%;
    
}
  .modal-close {
    color: #fff;
    line-height: 50px;
    font-size: 140%;
    position: absolute;
    right: 0;
    text-align: center;
    top: 2;
    width: 70px;
    text-decoration: none;
    &:hover {
      color: black;
    }
  }
  .modal-close-mobile {
    color: #fff;
    line-height: 50px;
    font-size: 140%;
    position: absolute;
    right: 0;
    text-align: center;
    top: 2;
    width: 70px;
    text-decoration: none;
    &:hover {
      color: black;
    }
    display: none;
  }
  .modal-window {
    & > div {
        border-radius: 63px;
    }
  }
  .modal-logo {
    text-align: center;
    margin-top: -10px;
  }
  .modal-logo > img {
    width: 100px;
    
}
h2 {
   
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 800;
    font-size: 10px;
    line-height: 42px;
    text-align: center;
    color: #FFFFFF;
    line-height: 190%;
    margin-top: 0px;

}

@media screen and (max-width: 768px) {

.modal-window {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 999;
    visibility: hidden;
    opacity: 0;
    pointer-events: none;
    transition: all 0.3s;
    &:target {
      visibility: visible;
      opacity: 1;
      pointer-events: auto;
    }
    & > div {
      width: 90%;
      height: 490px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      padding: 2em;
      border: 1px solid #2F2F2F;
      backdrop-filter: blur(13px);
      box-sizing: border-box;
    }
    header {
      font-weight: bold;
    }
    h1 {
      font-size: 150%;
      margin: 0 0 15px;
    }
  }
  .modal-container{
    display: flex;
    flex-direction: row;
}
  .modal-close {
    color: #fff;
    line-height: 50px;
    font-size: 140%;
    position: absolute;
    right: 0;
    text-align: center;
    top: 2;
    width: 70px;
    text-decoration: none;
    &:hover {
      color: black;
    }
    display: none;
  }
  .modal-close-mobile {
    color: #fff;
    line-height: 50px;
    font-size: 140%;
    position: absolute;
    right: 0;
    text-align: center;
    top: 2;
    width: 70px;
    text-decoration: none;
    &:hover {
      color: black;
    }
    display: block;
  }
  .modal-window {
    & > div {
        border-radius: 63px;
    }
  }
  .modal-logo > img {
    width: 90px;
    text-align: center;
}
h2 {
   
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 800;
    font-size: 17px;
    line-height: 42px;
    text-align: center;
    color: #FFFFFF;
    line-height: 190%;
    margin-top: 20px;

}

.terms {
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    line-height: 19px;
    text-align: center;
    color: #FFFFFF;

    span {
        color: #D33E74;
    }
}

}
.modal-mask {
    // position: fixed;
     z-index: 9998;
     top: 0;
     left: 0;
     //width: 100%;
     height: 100%;
     background: rgba(0, 0, 0, .5) !important;
     display: table;
     transition: opacity .3s ease;
     & > div {
         //width: 100%;
         height: 120px;
         position: absolute;
         top: 50%;
         left: 50%;
         transform: translate(-50%, -50%);
         //padding: 2em;
         border: 1px solid #2F2F2F;
         //backdrop-filter: blur(13px);
         background: #19181B;
         border-radius: 20px;
         box-sizing: border-box;
       }
       .profile-view2{
         box-sizing: border-box;
         border-radius: 20px;
         //position:relative;
         width: 100%;
         height: 100%;
         background: #111112;
         .profile-photo2{
             width: 100%;
             height: auto;
             background: linear-gradient(180deg, rgba(0, 0, 0, 0.25) 59.17%, rgba(0, 0, 0, 0.5) 80.14%), #2F2F2F;
         }
     }


     .profile-interest2{
         
         h3 {
             width: auto;
             height: 26px;
             font-family: 'DM Sans';
             font-style: normal;
             font-weight: 700;
             font-size: 20px;
             line-height: 26px;
             text-align: left;
             color: #FFFFFF;
             margin:20px;
         }
         .interests2{
             box-sizing: border-box;
             display: flex;
             flex-direction: row;
             justify-content: center;
             align-items: center;
             padding: 2px 8px;
             width: auto;
             height: 29px;
             background: #111112;
             border: 1px solid #D33E74;
             border-radius: 50px;
             color: #767475;
             font-size: 10px;
             margin: 4px;
 
         }
 
         .interests-info2 {
             display: flex;
             flex-direction: row;
             //padding: 0rem 3rem 5rem 1rem;
         }
     }
     .profile-relationship-goal2 {
         margin-top: -150px !important;
         h3 {
             width: auto;
             height: 26px;
             font-family: 'DM Sans';
             font-style: normal;
             font-weight: 700;
             font-size: 20px;
             line-height: 26px;
             text-align: left;
             color: #FFFFFF;
             margin:20px;
         }
         .relationship-goal2 {
             display: flex;
             flex-direction: row;
             padding: 2px;
             width: 70%;
             height: auto;
             background: rgba(255, 214, 0, 0.1);
             border-radius: 61px;
             color: #FFD600;
             font-size: 10px;
             margin: 20px;
             text-align: left;
         }
 
     }
     .btn-unmatch-report2 {
         display: flex;
         flex-direction: row;
         align-items: center;
         .btn-unmatch2 {
             box-sizing: border-box;
             display: flex;
             flex-direction: row;
             justify-content: center;
             align-items: center;
             padding: 10px;
             width: 55%;
             height: 30px;
             background: #111112;
             border: 1px solid #D33E74;
             border-radius: 82px;
             font-family: 'Source Sans 3';
             font-style: normal;
             font-weight: 400;
             font-size: 13px;
             line-height: 28px;
             color: #D33E74;
             margin: 20px;
             cursor: pointer;
         }
         .btn-unmatch3 {
             box-sizing: border-box;
             display: flex;
             flex-direction: row;
             justify-content: center;
             align-items: center;
             padding: 10px;
             width: 55%;
             height: 30px;
             background: #111112;
             border: 1px solid #D33E74;
             border-radius: 82px;
             font-family: 'Source Sans 3';
             font-style: normal;
             font-weight: 400;
             font-size: 13px;
             line-height: 28px;
             color: #b1acae;
             margin: 20px;
             cursor: pointer;
         }
         .btn-report2 {
             display: flex;
             flex-direction: row;
             justify-content: center;
             align-items: center;
             padding: 10px;
             width: 55%;
             height: 30px;
             background: #2D2D2D;
             border-radius: 82px;
             font-family: 'Source Sans 3';
             font-style: normal;
             font-weight: 400;
             font-size: 13px;
             line-height: 28px;
             color: #767475;
             margin-right: 10px;
             cursor: pointer;
         }
     }
}
.content-fluid {
    background: transparent;
}
.container {
    margin-top: 80px;
    width: 100%;
    min-height: 80vh;
}
.profile-container{
    display: flex;
    flex-direction: row;
}
.large-profile-pic {
  width: 140px;
  height: 140px;
  border-radius: 50%;
}

 .profile-image {
    display: flex;
    flex-direction: row;
    width: 100%;

    .img-profile {
        width: 60%;
        height: 60%;
        margin:2px;
        border-radius: 100px;
    }

    .profile-info {
        display: flex;
        flex-direction: column;
        justify-content: left;
        margin-top: 30px;

        h3 {
            font-family: 'Raleway';
            font-style: normal;
            font-weight: bold;
            font-size: 20px;
            text-align: left;
            color: #FFFFFF;
        }
        p {
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 500;
            font-size: 15px;
            text-align: left;
            color: #FFFFFF;
        }        
    }
    .bio-trials{
        display: flex;
        flex-direction: row;
        justify-content: left;
        align-items: center;
        color: #FFFFFF;
        font-family: 'Raleway';
        font-weight: 650;
    
        .btn-trial{
            background: #FFD600;
            border: solid 0;
            color: #000;
            border-radius: 10px;
            font-size: 11px;
            padding: 0.4rem;
        }
    }
    .bio-buttons{
        display: flex;
        flex-direction: row;
        justify-content: left;
        align-items: center;
        font-family: 'Raleway';
        font-weight: 650;

        .btn-tour{
            background: #D33E74;
            color: #000;
            border: solid 0;
            border-radius: 10px;
            font-size: 11px;
            padding: 0.4rem;
        }
        .btn-boost{
            background: green;
            border: solid 0;
            border-radius: 10px;
            font-size: 11px;
            padding: 0.4rem;
            color: #ddd;
        }
        .btn-activate{
            background: transparent;
            border: solid 0;
            font-size: 11px;
            color: #ddd;
            a{
                color: green;
                text-decoration: none;
            }
        }

        .btn-chat {
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 10px 8px;
        width: 70px;
        height: 30px;
        background: #007BFF;
        border: 0px solid;
        border-radius: 50px;
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 21px;
        text-align: center;
        color: #FFFFFF;
    }
        
    }
    .select-profile{
        background: linear-gradient(180deg, rgba(0, 0, 0, 0.08) 68.1%, rgba(0, 0, 0, 0.5) 78.43%), #2F2F2F;
        border: 3px solid #D33E74;
        border-radius: 50%;
        width: 145px;
        height: 145px;
        display: block;
        margin-top: 15px;
        margin-bottom: 25px;
    }
 }
 .profile-picture{
    display: flex;
    flex-direction: row;
    justify-content: left;
    margin-right: 10px;
 }
.profile-edit-button{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;

    .btn-edit {
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 10px 18px;
        width: 120px;
        height: 40px;
        background: #D33E74;
        border: 0.5px solid #D33E74;
        border-radius: 50px;
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 21px;
        text-align: center;
        color: #FFFFFF;
    }
}

.photo {
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 800;
    font-size: 16px;
    line-height: 28px;
    text-align: left;
    color: #FFFFFF;
    margin-left: -45px;
    margin-top: 10px;

}

 .edit-profile-top {
    width: 100%;
 }
 .user-interests{
    display: flex;
    flex-wrap: wrap;
    gap: 10px; /* spacing between buttons */
 }

 .btn-chips {
  padding: 8px 16px;
  border: none;
  background-color: #eee;
  border-radius: 20px;
  cursor: pointer;
  font-family: 'DM Sans', sans-serif;
  transition: background-color 0.3s;
}

.btn-chips:hover {
  background-color: #ddd;
}

 .edit-profile {
    color: #FFFFFF;
    font-size: 12px;
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 800;
    line-height: 28px;
    //text-align: center;
    color: #FFFFFF;
    cursor: pointer;
 }
 .img-profile{
    display: flex;
    flex-direction: row;
    justify-content: center;
 }
 .img-profile-edit{
    margin-top: 50px;
    margin-bottom: 50px;
    text-align: center;
 }
 .img-profile2 {
        width: 120px;
        height: 120px;
        background: url("../assets/no_image.png");
        background-size: cover;
        padding-bottom: 0rem;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        cursor: pointer;
        border-radius: 100px;
        //background: #D9D9D9;
    }
 .profile-content{
    display: flex;
    flex-direction: row;
    justify-content: center;
 }
 .column1{
    width: 400px;
    margin: 10px;
 }
 .button-container{
    display: flex;
    flex-direction: row;
    justify-content: center;
 }
 .label{
    font-family: 'DM Sans';
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    line-height: 26px;
    text-align: left;
    color: #FFFFFF;
    margin-left: 10px;
 }
 .input-textx {
    box-sizing: border-box;
    padding: 10px 52px;
    width: 100%;
    height: 45px;
    background: #2D2D2D;
    border: 0px solid #FFFFFF;
    border-radius: 50px;
    font-size: 12px;
    color: #fff !important;
 }
 .input-text {
    box-sizing: border-box;
    padding: 10px 52px;
    width: 350px;
    height: 45px;
    background: #2D2D2D;
    border: 0.5px solid #FFFFFF;
    border-radius: 50px;
    font-size: 12px;
    color: #fff !important;
 }

 .input-text-state {
    box-sizing: border-box;
    padding: 10px 52px;
    width: 350px;
    height: 45px;
    background: #2D2D2D;
    border: 0.5px solid #FFFFFF;
    border-radius: 50px;
    font-size: 12px;
    color: #fff !important;
 }
 .birthday{
    display: flex;
    flex-direction: row;
 }
 .input-select {
    box-sizing: border-box;
    align-items: center;
    padding: 10px 40px;
    width: 114px;
    height: 55px;
    background: #2D2D2D;
    border: 0px solid #FFFFFF;
    border-radius: 50px;
    color: #767475;
    font-size: 12px;
    margin: 2px;
}
.rel-goal{
    color:#D33E74;
    font-family: 'DM Sans';
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
}
.btn-save {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px;
    width: 400px;
    height: 45px;
    background: #D33E74;
    border-radius: 82px;
    font-family: 'Source Sans 3';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 28px;
    color: #FFFFFF;
    margin-top: 15px;
    margin-bottom: 40px;
}

.btn-chips {
    box-sizing: border-box;
    justify-content: center;
    align-items: center;
    padding: 4px 10px;
    width: auto;
    height: 25px;
    margin: 3px;
    margin-bottom: 20px;
    background: #0A070F;
    border: 0.5px solid #D33E74;
    border-radius: 50px;
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 16px;
    text-align: center;
    color: #D33E74;
}      

@media screen and (max-width: 700px) {
    .container{
        margin-top: 100px;
        padding: 0px 0px 0px 0px !important;
    }
    .profile-container{
        display: flex;
        flex-direction: column;
 
    }
    .profile-image {
        display: flex;
        flex-direction: column;
        align-items: center;

        .img-profile {
            width: 30%;
            height: 30%;

        }
        .profile-info {
            padding: 0 0 0 0px;
           
            h3 {
                font-family: 'Raleway';
                font-style: normal;
                font-weight: bold;
                font-size: 14px;
                line-height: 20px;
                text-align: center;
                color: #FFFFFF;
            }
            p {
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 500;
                font-size: 12px;
                line-height: 20px;
                text-align: center;
                color: #FFFFFF;
            }
          
        }
        .select-profile{
            width: 145px;
            height: 145px;
        }
     }
    .profile-edit-button{
        margin-top: 10px;
        margin-bottom: 20px;
    
        .btn-edit {
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 10px 18px;
            width: 100px;
            height: 35px;
            background: #D33E74;
            border: 0.5px solid #D33E74;
            border-radius: 50px;
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 500;
            font-size: 10px;
            line-height: 21px;
            text-align: center;
            color: #FFFFFF;
        }
    }
    .mobile-line{
        color: #767475;
        width: 100%;
    }
    .photo {
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 800;
        font-size: 18px;
        line-height: 28px;
        text-align: left;
        color: #FFFFFF;
        margin-left: 55px;
        margin-top: 50px;
    }
    .bio-trials{
        display: flex;
        flex-direction: row;
        justify-content: left;
        align-items: center;
        color: #FFFFFF;
        font-family: 'Raleway';
        font-size: 12px;
        button{
            box-sizing: border-box;
            width: auto;
            height: 20px;
            border-radius: 50px;
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 600;
            font-size: 10px;
            line-height: 21px;
            text-align: center;
            color: #FFFFFF;
        }
        .btn-trial{
            background: #FFD600 !important;
            width: auto !important;
            height: auto !important;
            font-size: 10px !important;
            padding: 4px !important;
            border-radius: 10px !important;
            border: solid 0;
            color: #000;
        }
    }
    .bio-buttons{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 100%;

        .btn-tour{
            background: #D33E74;
            color: #000;
            border: solid 0;
            border-radius: 10px;
            font-size: 10px;
            height: auto;
        }
        .btn-boost{
            border: solid 0;
            width: auto !important;
            height: auto !important;
            font-size: 10px !important;
            border-radius: 10px !important;
            padding: 0.4rem !important;
        }
        .btn-activate{
            background: transparent;
            border: solid 0;
            text-decoration: none;
            color: #ddd;;
            width: 40% !important;
            height: auto !important;
            font-size: 10px !important;

        }

        .btn-chat {
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 4px 2px !important;
            width: 70px !important;
            height: 35px;
            background: #007BFF;
            border: 0px solid;
            border-radius: 50px;
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 500;
            font-size: 10px;
            line-height: 21px;
            text-align: center;
            color: #FFFFFF;
        }
        
    }
 .edit-profile-top {
  margin-left: 0px;
 }

 .profile-content{
    display: flex;
    flex-direction: column;
 }
 .column1{
    width: 100%;
    margin: 0px;
 }
 .user-interests{
   
 }
 .edit-profile {
    color: #FFFFFF;
    font-size: 12px;
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 800;
    line-height: 28px;
    //text-align: center;
    color: #FFFFFF;
    cursor: pointer;
 }
 .img-profile-edit{
    margin-top: 50px;
    margin-bottom: 50px;

    .img-profile2 {
        width: 120px;
        height: 120px;
        background: url("../assets/no_image.png");
        background-size: cover;
        padding-bottom: 0rem;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        cursor: pointer;
        border-radius: 100px;

    }
 }
 .label{
    font-family: 'DM Sans';
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 26px;
    text-align: left;
    color: #FFFFFF;
    margin-left: 10px;
 }
 .input-text {
    box-sizing: border-box;
    padding: 10px 52px;
    width: 100%;
    height: 35px;
    background: #0A070F;
    border: 0.5px solid #FFFFFF;
    border-radius: 50px;
    font-size: 12px;
 }
 .birthday{
    display: flex;
    flex-direction: column;
 }
 .input-select {
    box-sizing: border-box;
    align-items: center;
    padding: 10px 40px;
    width: 100%;
    height: 45px;
    background: #2D2D2D;
    border: 0px solid #FFFFFF;
    border-radius: 50px;
    color: #fff;
    font-size: 12px;
    margin: 2px;
}
.rel-goal{
    color:#D33E74;
    font-family: 'DM Sans';
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
   
}
.btn-save {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px;
    width: 100%;
    height: 45px;
    background: #D33E74;
    border-radius: 82px;
    font-family: 'Source Sans 3';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 28px;
    color: #FFFFFF;
    margin-top: 15px;
}

}

</style>
